"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("core-js/es7/object");
var PS = require('@csod/predictive-search').PredictiveSearch;
var PredictiveSearch = (function (_super) {
    __extends(PredictiveSearch, _super);
    function PredictiveSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.fixAllIconsAccessibility = function () {
            var icons = document.querySelectorAll("\n        .p-icon-down-triangle,\n        .p-icon-magnifying-glass,\n        .predictor-icon,\n        [class*=\"icon\"]:not(input):not(button):not([role=\"button\"]),\n        .p-search-module [class*=\"icon\"]\n    ");
            Array.from(icons).forEach(function (icon) {
                if (icon.getAttribute("aria-hidden") === "true")
                    return;
                icon.setAttribute("tabindex", "-1");
                icon.setAttribute("aria-hidden", "true");
                if (icon.getAttribute("role") === "button" &&
                    !icon.onclick &&
                    !icon.getAttribute("data-interactive")) {
                    icon.removeAttribute("role");
                }
            });
        };
        return _this;
    }
    PredictiveSearch.prototype.componentDidMount = function () {
        this.fixAllIconsAccessibility();
    };
    PredictiveSearch.prototype.componentDidUpdate = function () {
        this.fixAllIconsAccessibility();
    };
    PredictiveSearch.prototype.render = function () {
        var _a = this.props, id = _a.id, value = _a.value, placeholder = _a.placeholder, minPredictLength = _a.minPredictLength, maxLength = _a.maxLength, errorMessage = _a.errorMessage, isEnabled = _a.isEnabled, ariaLabel = _a.ariaLabel, ariaLabelledBy = _a.ariaLabelledBy, isLoading = _a.isLoading, predictions = _a.predictions, noPredictionsMessage = _a.noPredictionsMessage, searchResultsPage = _a.searchResultsPage, debounceWait = _a.debounceWait, debounceMaxWait = _a.debounceMaxWait, iconName = _a.iconName, tag = _a.tag, changeQueryToSelectedOnSelect = _a.changeQueryToSelectedOnSelect, onChange = _a.onChange, onPredict = _a.onPredict, onSelect = _a.onSelect, onSearch = _a.onSearch;
        return React.createElement(PS, { id: id, value: value, placeholder: placeholder, minPredictLength: minPredictLength, maxLength: maxLength, errorMessage: errorMessage, isEnabled: isEnabled, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, isLoading: isLoading, predictions: predictions, noPredictionsMessage: noPredictionsMessage, searchResultsPage: searchResultsPage, debounceWait: debounceWait, debounceMaxWait: debounceMaxWait, iconName: iconName, tag: tag, changeQueryToSelectedOnSelect: changeQueryToSelectedOnSelect, onChange: onChange, onPredict: onPredict, onSelect: onSelect, onSearch: onSearch });
    };
    return PredictiveSearch;
}(React.Component));
PredictiveSearch.defaultProps = {
    id: null,
    value: '',
    placeholder: null,
    minPredictLength: 2,
    maxLength: null,
    errorMessage: null,
    isEnabled: true,
    ariaLabel: null,
    ariaLabelledBy: null,
    isLoading: false,
    predictions: null,
    noPredictionsMessage: null,
    searchResultsPage: null,
    debounceWait: 500,
    debounceMaxWait: 3000,
    iconName: 'magnifying-glass',
    tag: null,
    changeQueryToSelectedOnSelect: true
};
exports.PredictiveSearch = PredictiveSearch;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["PredictiveSearch"] = [];


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/PredictiveSearch/PredictiveSearch.js
// module id = 231
// module chunks = 0